import { useEffect, useState } from 'react';
import { getAuthHeaders } from '../utils/apiUtils';
import { ServerURI } from '../globals';

export async function fetchGeminiModels() {
  const response = await fetch(`${ServerURI}/admin/geminiModels`, { headers: await getAuthHeaders() });
  if (!response.ok) throw new Error('Unable to load available AI models.');
  return response.json();
}

export function canSelectGeminiModel(model, models, policyEnforced) {
  return typeof model === 'string' && !!model.trim() &&
    (!policyEnforced || models.some(option => option.value === model));
}

// Both admin selectors consume the server's rollout policy and model suggestions.
export function useGeminiModels() {
  const [models, setModels] = useState([]);
  const [defaultModel, setDefaultModel] = useState('');
  const [modelError, setModelError] = useState('');
  const [modelPolicyEnforced, setModelPolicyEnforced] = useState(false);
  useEffect(() => {
    let disposed = false;
    fetchGeminiModels().then(result => {
      if (!disposed) {
        setModels([...result.models].sort((a, b) => a.label.localeCompare(b.label, 'en')));
        setDefaultModel(result.defaultModel);
        setModelPolicyEnforced(result.policyEnforced === true);
      }
    }).catch(error => { if (!disposed) setModelError(error.message); });
    return () => { disposed = true; };
  }, []);
  return { models, defaultModel, modelError, modelPolicyEnforced };
}
